"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setGtmExtraData = exports.cleanGtmExtraData = exports.useGtmDefaultData = void 0;
const styled_components_1 = require("styled-components");
const parseUTMs_1 = require("./parseUTMs");
const helpers_1 = require("../helpers");
const env_config_1 = __importDefault(require("../env.config"));
const useGtmDefaultData = () => {
    const { locale, isLoggedIn, country, device, memberData, city } = (0, styled_components_1.useTheme)();
    if (city)
        (0, exports.setGtmExtraData)({ city });
    if (!(0, helpers_1.isClientSide)())
        return;
    // eslint-disable-next-line
    const { utm_medium, utm_campaign, utm_source } = (0, parseUTMs_1.parseUTMs)();
    // @ts-ignore
    window.gtmDefaultParams = {
        LoggedIn: isLoggedIn || "empty",
        Language: locale || "empty",
        Country: country || "empty",
        Device: device || "empty",
        MemberID: (memberData === null || memberData === void 0 ? void 0 : memberData.id) || "empty",
        Version: env_config_1.default.APP_VERSION || "empty",
        //@todo revert this after experiment with Adey for Google Analytics UTM checking
        // cMedium: utm_medium,
        // cName: utm_campaign,
        // cSource: utm_source,
    };
};
exports.useGtmDefaultData = useGtmDefaultData;
const cleanGtmExtraData = () => {
    (0, exports.setGtmExtraData)(null);
};
exports.cleanGtmExtraData = cleanGtmExtraData;
const setGtmExtraData = (data = null) => {
    const { selectedCpsOptions, category, subCategory, city, neighborhoods } = data || {};
    const extraData = {
        CP1: (0, helpers_1.labelHelper)(selectedCpsOptions === null || selectedCpsOptions === void 0 ? void 0 : selectedCpsOptions[0], "en") || "empty",
        CP2: (0, helpers_1.labelHelper)(selectedCpsOptions === null || selectedCpsOptions === void 0 ? void 0 : selectedCpsOptions[1], "en") || "empty",
        CP3: (0, helpers_1.labelHelper)(selectedCpsOptions === null || selectedCpsOptions === void 0 ? void 0 : selectedCpsOptions[2], "en") || "empty",
        CP4: (0, helpers_1.labelHelper)(selectedCpsOptions === null || selectedCpsOptions === void 0 ? void 0 : selectedCpsOptions[3], "en") || "empty",
        Category: (category === null || category === void 0 ? void 0 : category.reporting_name) || "empty",
        City: (0, helpers_1.capitalized)(city.name_english) /*capitalized(urlHelper(city, "en")).replaceAll("-", " ") || "empty"*/,
        Neighborhood: (0, helpers_1.labelHelper)(neighborhoods === null || neighborhoods === void 0 ? void 0 : neighborhoods[0], "en") || "empty",
        SubCategory: (subCategory === null || subCategory === void 0 ? void 0 : subCategory.reporting_name) || "empty",
    };
    // @ts-ignore
    window.gtmExtraData = extraData;
    return extraData;
};
exports.setGtmExtraData = setGtmExtraData;
